import React from 'react';
import { RotateCcw, Clock, Package, AlertCircle, CheckCircle, FileText } from 'lucide-react';

const Returns = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            İade & Değişim
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            İade ve değişim politikamız hakkında bilgi alın
          </p>
        </div>

        {/* İade Süresi */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-6">
            <Clock className="h-8 w-8 text-orange-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-900">İade Süresi</h2>
          </div>
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-6">
            <p className="text-lg text-gray-900 mb-2">
              <strong>14 Gün İade Hakkı</strong>
            </p>
            <p className="text-gray-700">
              Ürünlerinizi teslim aldığınız tarihten itibaren 14 gün içinde, 
              ürünün kutusu açılmamış, hasar görmemiş ve kullanılmamış olması 
              şartıyla iade edebilir veya değiştirebilirsiniz.
            </p>
          </div>
        </div>

        {/* İade Koşulları */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="flex items-center mb-4">
              <CheckCircle className="h-6 w-6 text-green-600 mr-3" />
              <h3 className="text-xl font-bold text-gray-900">İade Edilebilir Ürünler</h3>
            </div>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Kutusu açılmamış ürünler</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Etiketleri yerinde olan ürünler</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Hasarsız ve kullanılmamış ürünler</span>
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-2">✓</span>
                <span>Faturası ve tüm aksesuarları ile birlikte gelen ürünler</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="flex items-center mb-4">
              <AlertCircle className="h-6 w-6 text-red-600 mr-3" />
              <h3 className="text-xl font-bold text-gray-900">İade Edilemeyecek Ürünler</h3>
            </div>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="text-red-600 mr-2">✗</span>
                <span>Kişisel bakım ürünleri</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-2">✗</span>
                <span>Kutusu açılmış veya kullanılmış ürünler</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-2">✗</span>
                <span>Hasarlı veya eksik parçalı ürünler</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-2">✗</span>
                <span>14 günlük süreyi aşan ürünler</span>
              </li>
            </ul>
          </div>
        </div>

        {/* İade Süreci */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">İade Süreci</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">1</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">İade Talep Et</h3>
              <p className="text-sm text-gray-600">
                Müşteri hizmetlerimizle iletişime geçerek iade talebinizi oluşturun
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">2</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Paketle</h3>
              <p className="text-sm text-gray-600">
                Ürünü orijinal kutusu ve faturası ile birlikte paketleyin
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">3</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Kargo</h3>
              <p className="text-sm text-gray-600">
                Size gönderilecek kargo etiketini yapıştırarak kargoya verin
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">4</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">İade</h3>
              <p className="text-sm text-gray-600">
                Ürün kontrol edildikten sonra iadeniz onaylanır ve ödemeniz iade edilir
              </p>
            </div>
          </div>
        </div>

        {/* İade Ücreti */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-4">
            <Package className="h-8 w-8 text-orange-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-900">İade Kargo Ücreti</h2>
          </div>
          <div className="space-y-4">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <p className="text-gray-900 mb-2">
                <strong>Ürün Hatası veya Yanlış Ürün Gönderimi:</strong>
              </p>
              <p className="text-gray-700">
                Eğer ürün hatası varsa veya yanlış ürün gönderildiyse, iade kargo ücreti tarafımızca karşılanır.
              </p>
            </div>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
              <p className="text-gray-900 mb-2">
                <strong>Müşteri Kaynaklı İade:</strong>
              </p>
              <p className="text-gray-700">
                Eğer ürün hatası yoksa ve sadece beğenmediğiniz için iade ediyorsanız, 
                iade kargo ücreti tarafınıza aittir.
              </p>
            </div>
          </div>
        </div>

        {/* Para İadesi */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <div className="flex items-center mb-4">
            <RotateCcw className="h-8 w-8 text-orange-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-900">Para İadesi</h2>
          </div>
          <div className="space-y-4">
            <p className="text-gray-700">
              Ürün kontrol edilip onaylandıktan sonra, para iadeniz aşağıdaki sürelerde gerçekleştirilir:
            </p>
            <ul className="space-y-2 text-gray-700 list-disc list-inside">
              <li><strong>Kredi/Banka Kartı:</strong> 5-7 iş günü içinde</li>
              <li><strong>Havale/EFT:</strong> 1-2 iş günü içinde</li>
            </ul>
          </div>
        </div>

        {/* Değişim */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Ürün Değişimi</h2>
          <p className="text-gray-700 mb-4">
            Ürün değişimi için önce mevcut ürünü iade etmeniz, sonra yeni ürünü sipariş etmeniz gerekmektedir. 
            Ürün fiyat farkı varsa, fark ödenmesi gerekmektedir.
          </p>
          <p className="text-gray-700">
            Değişim işlemi için lütfen müşteri hizmetlerimizle iletişime geçin.
          </p>
        </div>

        {/* Sık Sorulan Sorular */}
        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">İade Hakkında Sık Sorulan Sorular</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                İade için ne kadar sürem var?
              </h3>
              <p className="text-gray-600">
                Ürünü teslim aldığınız tarihten itibaren 14 gün içinde iade edebilirsiniz.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                İade için ürünü nasıl gönderebilirim?
              </h3>
              <p className="text-gray-600">
                Müşteri hizmetlerimizle iletişime geçerek iade talebinizi oluşturduktan sonra, 
                size gönderilecek kargo etiketini ürünün üzerine yapıştırarak kargoya verebilirsiniz.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Para iadesi ne zaman hesabıma geçer?
              </h3>
              <p className="text-gray-600">
                Ürün kontrol edilip onaylandıktan sonra, ödeme yönteminize göre 1-7 iş günü içinde 
                para iadeniz gerçekleştirilir.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Ürünü değiştirebilir miyim?
              </h3>
              <p className="text-gray-600">
                Evet, ürün değişimi yapabilirsiniz. Bunun için önce mevcut ürünü iade etmeniz, 
                sonra istediğiniz ürünü sipariş etmeniz gerekmektedir.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Returns;








